<template>
  <div class="bghover">
    <div class="content-head paddingLeftRight">
      <h3>各季度污染物数据缺失率</h3>
      <el-divider content-position="left"></el-divider>
      <el-form :model="formLabelAlign" class="textAlignLeft">
        <el-form-item label="评估污染物" class="marginZero">
          <el-radio-group v-model="assessPull" @change="assessChange">
            <el-radio label="PM2.5">PM2.5</el-radio>
            <el-radio label="PM10">PM10</el-radio>
            <el-radio label="SO2">SO2</el-radio>
            <el-radio label="NO2">NO2</el-radio>
            <el-radio label="CO">CO</el-radio>
            <el-radio label="O3">O3</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="评估年份">
          <el-date-picker
            v-model="assessYear"
            type="year"
            placeholder="选择评估年份"
            :picker-options="pickerOptions"
            @change="assessChange"
            size="mini"
          ></el-date-picker>
          <el-select
            size="mini"
            v-model="assessSeason"
            placeholder="请选择"
            @change="assessChange"
          >
            <el-option
              v-for="item in Seasons"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="content-body">
      <div
        :id="'data-area-top-chart'"
        :style="{ height: eleheight + 'px' }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.content-body i {
  font-size: 26px;
  color: #909399;
}

.content-body i:hover {
  color: #409eff;
}

.content-body .play {
  display: inline-block;
  line-height: 26px;
  height: 26px;
  text-align: center;
}
</style>

<script>
// // @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "DataCity",
  data() {
    return {
      // assessPull: "PM2.5",
      assessCity: ["直辖市", "北京"],
      assessCityEn: "Beijing",
      eleheight: 360,
      props: { multiple: false, expandTrigger: "hover" },
      options: [],
      dynamic: "pause",
      cities: [],
      chart: [],
      miss_data: [],
      assessYear: "2022",
      assessSeason: 1,
      assessType: "top",
      assessPull: "PM2.5",
      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2022 || time.getFullYear() < 2013;
        },
      },
    };
  },
  created() {
    const that = this;
    // 获取城市
    this.$axios
      .post("/AQAssess/getData.php", {
        database: "cities",
      })
      .then((res) => {
        that.cities = res.data;
        let options = [];
        that.cities.forEach((element) => {
          let add = false;
          for (let i = 0; i < options.length; i++) {
            if (options[i].value == element[0]) {
              options[i].children.push({
                value: element[1],
                label: element[1],
              });

              add = true;
              break;
            }
          }
          if (!add) {
            options.push({
              value: element[0],
              label: element[0],
              children: [{ value: element[1], label: element[1] }],
            });
          }
        });

        that.options = options;
      })
      .catch((e) => {
        this.$message({
          type: "info",
          message: "获取城市数据失败",
        });
      });
  },
  methods: {
    addCityEn() {
      this.cities.forEach((prov) => {
        if (prov[1] == this.assessCity[1]) {
          this.assessCityEn = prov[2];
          return;
        }
      });
    },

    assessChange() {
      this.updateCharts();
    },

    dynamicChange() {
      if (this.dynamic == "pause") {
        this.dynamic = "play";
      } else {
        this.dynamic = "pause";
      }
    },
    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getMissData();
    },

    getMissData() {
      this.addCityEn();
      let assYear = this.assessYear;
      if (typeof assYear == "string" && assYear.constructor == String) {
        assYear = this.assessYear;
      } else {
        assYear = assYear.getFullYear() + "";
      }
      this.$axios
        .post("/AQAssess/getData.php", {
          database: "area_miss",
          year: assYear,
          season: this.assessSeason,
          pull: this.assessPull,
        })
        .then((res) => {
          // console.log(res.data);

          let miss_data = [];
          res.data.forEach((element) => {
            if (element[0] != null) {
              miss_data.push([
                element[0],
                parseFloat(100 * element[1]).toFixed(1),
                element[2],
              ]);
            }
          });

          let seasonZh = ["春", "夏", "秋", "冬"];

          if (miss_data.length == 0) {
            this.$message({
              message:
                this.assessYear +
                seasonZh[this.assessSeason - 1] +
                this.assessPull +
                "无缺失率数据",
              type: "warning",
            });
          } else {
            let time = assYear + seasonZh[this.assessSeason - 1];
            this.drawAreaTopChart(
              this.chart[0],
              miss_data,
              time,
              this.assessPull
            );
          }
        });
    },

    drawAreaTopChart(chart, miss_data, time, pull) {
      // 转换成 heatmap data 格式[x, y, value]

      // miss_data 排序
      miss_data.sort(function (a, b) {
        return a[1] - b[1];
      });

      let title = time + "各城市" + pull + "缺失率及排名";

      let option = {
        title: {
          text: title,
          // subtext: title,
          padding: [
            25, // 上
            10, // 右
            5, // 下
            10, // 左
          ],
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let text = pull + "<br>";
            params.forEach((param) => {
              text +=
                param.marker + param.data[0] + "缺失率: " + param.data[1] + "%";
            });

            return text;
          },
        },

        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            right: 40,
            startValue: 0,
            endValue: 28,
          },

          // {
          //   type: "inside",
          //   xAxisIndex: [0],
          //   startValue: 0,
          //   endValue: 20,
          // },
        ],
        grid: {
          left: 20,
          right: 40,
          bottom: 50,
          containLabel: true,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          name: "%",
        },
        xAxis: {
          type: "category",
        },
        series: [
          {
            type: "bar",
            data: miss_data,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)",
            },
            label: {
              show: true,
              position: "top",
              color: "red",
              formatter: function (params) {
                return "#" + params.data[2];
              },
            },
          },
        ],
      };
      chart.setOption(option);
      chart.hideLoading();
    },
  },
  mounted() {
    // for (let i = 1; i <= 6; i++) {
    //   this.chart.push(
    //     this.$echarts.init(document.getElementById("data-area-top-chart-" + i))
    //   );
    // }

    this.chart.push(
      this.$echarts.init(document.getElementById("data-area-top-chart"))
    );

    this.updateCharts();

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
};
</script>



